<script>
/*
<template functional>
  <div>
    <small v-if="props.model.$error" class="text-sm text-danger">{{props.model.$error}}</small>
  </div>
</template>

*/
export default {
  name: 'w-warning',
  props: ['model', 'id'],
  render(h, context) {
    /* if (context.sectionName === undefined) {
      context.sectionName = null;
      let parent = context.parent;
      while (parent) {
        if (parent.sectionName) {
          context.sectionName = parent.sectionName;
          break;
        }
        parent = parent.$parent;
      }
    }
    context.props.model.$formSection = context.sectionName;
    */
    const err = this.model.$warnings && this.model.$warnings[0];

    if (this.model.$form.testPath) {
      if (process.env.NODE_ENV !== 'production') {
        console.log(this.model.$path + '.$error');
      }
      return h('div', {}, err ? [h('small', {class: 'text-sm text-warning', attrs: {'data-path': this.model.$path + '.$warnings', id: this.id}}, this.checkWarn)] : []);
    } else if (!this.model.$disabled) {
      return h('div', {}, err ? [h('small', {class: 'text-sm text-warning', attrs: {id: this.id}}, this.checkWarn)] : []);
    } else {
      return h('div', {}, []);
    }
    /*

    const opts = {
      class: 'text-sm text-danger',
      domProps: {}
    };
    if (this.model.$form.generateId) {
      opts.domProps.id = this.model.$pathId + '_error';
    }
    if (this.model.$form.testPath) {
      opts.domProps['data-path'] = this.model.$path + '.$error';
    }
    return h('div', {}, err ? [h('small', opts, err)] : []);
    */

    /*

    if (this.model.$form.generateId) {
      return h('div', {}, err ? [h('small', {class: 'text-sm text-danger', domProps: {id: this.model.$pathId + '_error'}}, err)] : []);
    } else {
      return h('div', {}, err ? [h('small', {class: 'text-sm text-danger'}, err)] : []);
    }
    */
  },
  computed: {
    checkWarn() {
      if (!this.model.$warnings || !this.model.$warnings.length || this.model.$warnings[0].toLowerCase().startsWith('uwaga:')) {
        return this.model.$warnings[0];
      }
      return `Uwaga: ${this.model.$warnings[0]}`;
    }
  }
};
</script>
